export type Theme = 'dark' | 'light'
const KEY = 'expas-theme'

export function getTheme(): Theme {
  return (document.documentElement.getAttribute('data-theme') as Theme) ?? 'dark'
}

export function setTheme(theme: Theme) {
  document.documentElement.setAttribute('data-theme', theme)
  localStorage.setItem(KEY, theme)
}

/** Apply the persisted theme (falls back to the dark lead) on boot. */
export function initTheme() {
  const saved = localStorage.getItem(KEY) as Theme | null
  setTheme(saved ?? 'dark')
}
